export default "__VITE_ASSET__DWF2PSly__"